import { render } from "./ControlOverInvoices.vue?vue&type=template&id=58640e5c&scoped=true"
import script from "./ControlOverInvoices.vue?vue&type=script&lang=js"
export * from "./ControlOverInvoices.vue?vue&type=script&lang=js"

import "./ControlOverInvoices.vue?vue&type=style&index=0&id=58640e5c&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58640e5c"]])

export default __exports__